import angular from 'angular';

(function() {
    'use strict';

    var core = angular.module('app.core');

    // ----------------------
    // Configuration compiler
    // ----------------------
    core.config(compiler);

    compiler.$inject = ['$compileProvider'];

    function compiler($compileProvider) {
        // Supprimer les informations de DEBUG d'Angular
        // Informations activable en tapant dans la console : angular.reloadWithDebugInfo();
        $compileProvider.debugInfoEnabled(false);
    }

    // ------------------
    // Configuration HTTP
    // ------------------
    core.config(http);

    http.$inject = ['$httpProvider'];

    function http($httpProvider) {
        // Passe un header X-Requested-With pour désactiver la popup du navigateur demandant une authentification BASIC
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    }

    // -------------------------
    // Configuration Restangular
    // -------------------------
    core.config(restangular);

    restangular.$inject = ['RestangularProvider', 'CONF'];

    function restangular(RestangularProvider, CONF) {
        RestangularProvider.setBaseUrl(CONF.apiContext);
    }

    // ---------------------------------------
    // Configuration de l'internationalisation
    // ---------------------------------------
    core.config(translation);

    translation.$inject = ['$translateProvider', 'I18N', 'CONF'];

    function translation($translateProvider, I18N, CONF) {
        $translateProvider.uniformLanguageTag('bcp47'); // Converti la langue selon la règle BCP47, ex: en-US => en-US en_US => en-US en-us => en-US
        $translateProvider.preferredLanguage('fr');

        // Indique que pour les locales fr-* on nutilise la locale fr
        $translateProvider.registerAvailableLanguageKeys(['fr'], {
            'fr-*': 'fr'
        });

        // Chargement des JSON contenant les traductions
        $translateProvider.useStaticFilesLoader({
            prefix: CONF.appContext + '/resources/lang/locale-',
            suffix: '.json'
        });

        $translateProvider.fallbackLanguage(I18N.locales.fallbackLanguage); // Fallback si un des
        $translateProvider.useSanitizeValueStrategy('escaped'); // Pour la sécurité
    }

    // --------------------------------------------------
    // Configuration Toastr pour l'affichage des messages
    // --------------------------------------------------
    core.config(toastrSetup);

    toastrSetup.$inject = ['toastrConfig'];

    /* @ngInject */
    function toastrSetup(toastrConfig) {
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
    }

    // --------------------------------------------------
    // Configuration UI Select
    // --------------------------------------------------
    core.config(uiSelectSetup);

    uiSelectSetup.$inject = ['uiSelectConfig'];

    /* @ngInject */
    function uiSelectSetup(uiSelectConfig) {
        uiSelectConfig.theme = 'bootstrap';
    }

    // --------------------------------------------------
    // Configuration intercepteur HTTP
    // --------------------------------------------------
    core.config(httpInterceptor);

    httpInterceptor.$inject = ['$httpProvider', '$provide'];

    function httpInterceptor($httpProvider, $provide) {
        $httpProvider.interceptors.push('bokissHttpInterceptor');

        // Interceptor definition
        $provide.factory('bokissHttpInterceptor', bokissHttpInterceptor);

        bokissHttpInterceptor.$inject = ['$q'];

        /* @ngInject */
        function bokissHttpInterceptor($q) {
            var exports = {
                request: request,
                requestError: requestError,
                response: response,
                responseError: responseError
            };
            return exports;

            /////////////////////////
            function request(req) {
                return req;
            }

            function requestError(rejection) {
                return $q.reject(rejection);
            }

            function response(resp) {
                return resp;
            }

            function responseError(rejection) {
                return $q.reject(rejection);
            }
        }
    }

    core.config(setUiGridDefault);

    setUiGridDefault.$inject = ['$provide'];

    function setUiGridDefault($provide) {
        $provide.decorator('GridOptions', [
            '$delegate',
            function($delegate) {
                var gridOptions = angular.copy($delegate);
                gridOptions.initialize = function(options) {
                    var initOptions;
                    initOptions = $delegate.initialize(options);
                    initOptions.enableColumnMenus = options.enableColumnMenus || false;
                    initOptions.paginationPageSizes = options.paginationPageSizes || [20, 50, 100];
                    initOptions.paginationPageSize = options.paginationPageSize || 20;
                    initOptions.rowHeight = options.rowHeight || 30;
                    return initOptions;
                };
                return gridOptions;
            }
        ]);
    }

    // --------------------------------------------------
    // Configuration du délai de session
    // --------------------------------------------------
    core.config(startUp);

    startUp.$inject = ['KeepaliveProvider', 'IdleProvider'];

    function startUp(KeepaliveProvider, IdleProvider) {
        IdleProvider.idle(1800);
        IdleProvider.timeout(60);
        KeepaliveProvider.interval(60);
    }

    // --------------------------------------------------
    // Configuration de l'indicateur de chargement
    // --------------------------------------------------
    core.config(busy);

    busy.$inject = ['angularBusyDefaults'];

    function busy(angularBusyDefaults) {
        angularBusyDefaults.message = 'Veuillez patienter';
        angularBusyDefaults.templateUrl = require('../components/busy-indicator.html');
    }

    // --------------------------------------------------
    // Configuration de la gestion des exceptions
    // --------------------------------------------------
    core.config(exceptionConfig);

    exceptionConfig.$inject = ['$provide'];

    function exceptionConfig($provide) {
        // Mise en place d'un décorateur sur le gestionnaire d'exception par défaut (qui loggue sur la console)
        $provide.decorator('$exceptionHandler', extendExceptionHandler);
    }

    extendExceptionHandler.$inject = ['$delegate', '$injector'];

    function extendExceptionHandler($delegate, $injector) {
        return function(exception, cause) {
            $delegate(exception, cause);

            var kissStackTraceService = $injector.get('kissStackTraceService');
            kissStackTraceService.sendStackTrace(exception, cause);
        };
    }
})();
